module.exports = __webpack_public_path__ + "static/media/BlanchedSplits.24ad7250.pdf";